import { z } from 'zod';
import type { NotificationAlertReceipt } from '../types/notification-alert.types';

/** Validates the small identity-only cross-tab receipt before retaining it. */
export const notificationAlertReceiptSchema = z.object({
  tenantId: z.string().min(1).max(160),
  userId: z.string().min(1).max(160),
  messageId: z.string().min(1).max(512),
}) satisfies z.ZodType<NotificationAlertReceipt>;
